import React from "react";
import { Col, Row } from "@vds/grids";
import { useTranslation } from "react-i18next";
import { Body } from "@vds/typography";
import { MarginSpacerL } from "common/components/styleTag.js";
import { TextLink } from "@vds/buttons";
import styled from "styled-components";
import { Icon } from "@vds/icons";


const TileContainer = styled.div`
  width: 100%;
//   min-height: 252px;
  flex-shrink: 0;
  border-radius: 0px;
  border: 1px solid #0f0f0f;
  background: #fff;
  padding: 1.5rem 1rem;
  > div [class*="column-gap"] {
        column-gap : 80px;
        @media only screen and (max-width: 545px){
            column-gap : 20px;
        }
  }
`;

const ContactWrapper = styled.div`
display:flex;
align-items:center;
}
`;

const NoStoreDetails = styled.div`
padding:30px;
`

const StoreAddress = ({ storeAppointmentInfo }) => {
    const { t, i18n } = useTranslation(["app"]);
    const storeDetail = storeAppointmentInfo?.storeDetail
    // const storeQueryParams = JSON.parse(sessionStorage.getItem('storeQueryParams')) || {};
    // const url = `shop/store-appointment?storeId=${storeQueryParams?.storeId}&retailId=${storeQueryParams?.retailId}&zip=${storeQueryParams?.zip}&state=${storeQueryParams?.state}&lat=${storeQueryParams?.lat}&long=${storeQueryParams?.long}&slDomain=${storeQueryParams?.slDomain}&channel=${storeQueryParams?.channel}&slApptUrl=${storeQueryParams?.slApptUrl}&qParam=${storeQueryParams?.qParam}`

    const handlePhoneFormat = (phone) => {
        phone = phone?.replace(/(\d{3})(\d{3})(\d{4})/gi, '$1.$2.$3');
        return phone;
    }

    return (

            <Row>
                <TileContainer>
                    {storeDetail?.address1 ? 
                    <>
                    <Row className="column-gap">
                        <Col  colSizes={{ mobile: 4 ,tablet: 6, desktop: 6 }} >
                            <Body bold size="large" >
                                {storeDetail?.storeName ?? "Name of Company"}
                            </Body>
                            <Body size="medium" >
                                {storeDetail?.city ?? "Address of customer"}
                            </Body>
                            <Body size="medium" >
                                {storeDetail?.address1 ?? "City and Pin "}
                            </Body>
                            <MarginSpacerL />
                        </Col>
                        <Col colSizes={{ mobile: 4 ,tablet: 6, desktop: 6 }} >
                            <ContactWrapper>
                                <Icon
                                    name="on-go-car"
                                    color="#000000"
                                    size="medium"
                                />
                                <TextLink
                                    href={`https://google.com/maps/place/+${storeDetail?.address1}+','+${storeDetail?.city}+','+${storeDetail?.state}+','+${storeDetail?.zip}`}
                                    target="_blank"
                                >
                                    {t("app.common.storeAppointment.getDirections", { ns: "app" })}
                                </TextLink>
                            </ContactWrapper>
                            <MarginSpacerL />
                        </Col>
                    </Row>
                    </> : 
                    <Row>
                        <NoStoreDetails>
                        <Body bold size="medium" >
                        {t("app.common.storeAppointment.noStoreDetails", { ns: "app" })}
                        </Body>
                        </NoStoreDetails>
                    </Row>
                  }
                </TileContainer>
            </Row>
    );
};
export default StoreAddress;